import logo from '../../assets/img/logo.png';
import yourTv from '../../assets/img/your-tv.svg';
import downloadOffline from '../../assets/img/download-offline.svg';
import WatchEverywhere from '../../assets/img/Watch-everywhere.svg';
import createProfilesKids from '../../assets/img/create-profiles-kids.svg';
import LoginFooter from '../../Component/Footer';
import { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactFragment, ReactPortal, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { GET_TRENDING_REQUEST } from '../../redux/types';
import { GET_INITIAL_API_SUCCESS } from '../../redux/types';
import { get, initialApiUrl } from "../../api";


const NewSignup = () => {
  // const apiResponse = useSelector((state: any) => state.initialApi);

  // console.log("apiResponse" ,apiResponse)
  // <pre>{JSON.stringify(apiResponse, null, 2)}</pre>

  const postData = async (url: string, data: any) => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      setTrendingData(result.data);
      return result;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const faqData = [
    { name: "What is Darkroom?", conts: "Darkroom is a streaming platform that brings you a huge selection of award-winning TV shows, movies, anime, documentaries, and more—all accessible on thousands of internet-connected devices." },
    { name: "How much does Darkroom cost?", conts: "Enjoy Darkroom on your phone, tablet, Smart TV, laptop, or streaming device with one simple monthly plan. Subscription options start at just $1.99 and go up to $4.99. No hidden fees. No contracts." },
    { name: "Where can I watch Darkroom?", conts: "Watch anytime, anywhere. Log in at darkroom.film from your computer or stream instantly using the Darkroom app on smart TVs, mobile devices, tablets, streaming sticks, and gaming consoles (coming soon)." },
    {
      name: "How do I cancel my subscription?", conts: (
        <>
          Darkroom offers total flexibility—no long-term commitments or hidden fees.
          You can cancel your subscription anytime online in just a couple of clicks.
          There are no cancellation charges, so you're free to come and go as you like.
          <br /><br />
          <strong>Cancel via your platform:</strong>
          <ul>
            <li>
              Google (Android/Android TV):{" "}
              <a
                href="https://play.google.com/store/account/subscriptions?pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Manage on Google Play
              </a>
            </li>
            <li>
              Apple (iOS/Apple TV):{" "}
              <a
                href="https://support.apple.com/en-in/118428"
                target="_blank"
                rel="noopener noreferrer"
              >
                Manage on Apple Support
              </a>
            </li>
          </ul>
        </>
      )
    },
    { name: "What can I watch on Darkroom?", conts: "From blockbuster movies and trending series to anime, documentaries, and exclusive Darkroom Originals, there's always something great to watch, whenever you want." },
  ];

  const [faqActive, setFaqShowHide] = useState<number | null>(null);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(1);
  const [emailError, setEmailError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [capchaSelected, setCapchaSelected] = useState('');
  const [error, setError] = useState('');
  const [trendingData, setTrendingData] = useState<any>();
  const [captchaRendered, setCaptchaRendered] = useState(false);
  
  // ADD THESE NEW STATE VARIABLES AND REFS FOR OTP AUTO-FOCUS
  const [otp, setOtp] = useState(['', '', '', '']);
  const otpRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [invalidError ,setInvalidError] = useState('')
  
  const captchaRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const showhFaq = (item: number | null) => {
    setFaqShowHide(item);
  };

  // AUTO FOCUS ON FIRST OTP INPUT WHEN STEP 3 IS REACHED
  useEffect(() => {
    if (step === 3 && otpRefs.current[0]) {
      setTimeout(() => {
        otpRefs.current[0]?.focus();
      }, 100);
    }
  }, [step]);

  // OTP INPUT HANDLERS
  const handleOtpChange = (index: number, value: string) => {
    // Only allow single digit
    if (value.length > 1) return;
    
    // Only allow numbers
    if (value && !/^\d$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto move to next input if value is entered and not the last input
    if (value && index < 3) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle backspace - move to previous input if current is empty
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
    
    // Handle left arrow key
    if (e.key === 'ArrowLeft' && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
    
    // Handle right arrow key
    if (e.key === 'ArrowRight' && index < 3) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, ''); // Remove non-digits
    
    if (pastedData.length > 0) {
      const newOtp = [...otp];
      for (let i = 0; i < Math.min(pastedData.length, 4); i++) {
        newOtp[i] = pastedData[i];
      }
      setOtp(newOtp);
      
      // Focus on the next empty input or the last input
      const nextIndex = Math.min(pastedData.length, 3);
      otpRefs.current[nextIndex]?.focus();
    }
  };

  useEffect(() => {
    dispatch({ type: GET_INITIAL_API_SUCCESS, response: { dev_base_url: initialApiUrl } });
    dispatch({ type: GET_TRENDING_REQUEST, userId: '', range: 0 });
  }, [dispatch]);

  useEffect(() => {
    const url = `${initialApiUrl}/trending-videos`;
    const data = {
      user_id: '',
      start_range: 0,
    };
    postData(url, data);
  }, []);

  // Load reCAPTCHA script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      // console.log('reCAPTCHA script loaded successfully');
    };
    script.onerror = () => {
      console.error('Failed to load reCAPTCHA script');
      setError('Failed to load captcha. Please refresh the page.');
    };
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  // Render captcha when step 3 is reached
  useEffect(() => {
    if (step === 3 && window.grecaptcha && captchaRef.current && !captchaRendered) {
      try {
        // Clear any existing captcha first
        if (captchaRef.current.innerHTML) {
          captchaRef.current.innerHTML = '';
        }
        
        window.grecaptcha.render(captchaRef.current, {
          sitekey: "6LeyGpopAAAAAJRjB_7MZwuvIVc0A2exj17o8W4A",
          callback: (response: string) => {
            setCapchaSelected(response);
            setError("");
          },
          'expired-callback': () => {
            setCapchaSelected('');
            setError("Captcha expired. Please verify again.");
          },
          'error-callback': () => {
            setError("Captcha error occurred. Please try again.");
          }
        });
        setCaptchaRendered(true);
      } catch (error) {
        console.error('Error rendering captcha:', error);
        setError('Error loading captcha. Please refresh the page.');
      }
    }
  }, [step, captchaRendered]);

  // Reset captcha and OTP when leaving step 3
  useEffect(() => {
    if (step !== 3) {
      setCaptchaRendered(false);
      setCapchaSelected('');
      setOtp(['', '', '', '']); // RESET OTP WHEN LEAVING STEP 3
    }
  }, [step]);

  const handleFirstStep = (event: any) => {
    event.preventDefault();
    const usernameVal = event.target.UserName ? event.target.UserName.value.trim() : '';
    const emailVal = event.target.email ? event.target.email.value.trim() : '';
    let valid = true;
    
    setUsernameError(false);
    setEmailError(false);
    
    if (!usernameVal) {
      setUsernameError(true);
      valid = false;
    }
    if (!emailVal || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailVal)) {
      setEmailError(true);
      valid = false;
    }
    if (valid) {
      setUsername(usernameVal);
      setEmail(emailVal);
      setStep(2);
    }
  };

  const handleSecondStep = async (event: any) => {
    event.preventDefault();
    
    const passwordVal = event.target.password ? event.target.password.value : '';
    setPasswordError(false);
    
    if (!passwordVal) {
      setPasswordError(true);
      return;
    }
    
    setPassword(passwordVal);
    
    try {
      const response = await axios.post(`${initialApiUrl}/sign-up-new`, {
        username: username,
        email: email,
        password: passwordVal,
        confirm_password: passwordVal,
        signup_type: 1
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('API response:', response.data);
      toast(response.data.message);
      
      if (response.data.status_code === 2) {
        navigate('/signin');
      } else if (response.data.status_code === 1) {
        setStep(3);
      }
    } catch (error: any) {
      const apiMessage = error.response?.data?.message || error.message;
      console.error('API error:', error);
      toast(`An error occurred. Please try again. ${apiMessage}`);
    }
  };

  const handleOtpStep = async (event: any) => {
    event.preventDefault();
    
    // Validate captcha first
    if (!capchaSelected) {
      setError('Please complete the captcha verification.');
      toast('Please complete the captcha verification.');
      return;
    }
    
    // USE OTP FROM STATE INSTEAD OF FORM VALUES
    const otpCode = otp.join('');
    
    if (otpCode.length !== 4) {
      toast('Please enter the 4-digit OTP code.');
      return;
    }
    
    try {
      const response = await axios.post(`${initialApiUrl}/account-verification-with-otp`, {
        username: username,
        email: email,
        password: password,
        confirm_password: password,
        mail_type: 'NEW-REGISTRATION',
        opt: otpCode,
        captcha_response: capchaSelected // Include captcha response if your backend needs it
      });

      if (response.data.status_code === 1) {
        toast(response.data.message);
        setInvalidError('')

        // Format the response to match what the normal login flow returns
        const loginData = {
          rootUserDetail: {
            token: response.data.bearer_token,
            userToken: response.data.user_token,
            user_id: response.data.data.user_id,
          },
          token: response.data.bearer_token,
          ...response.data.data,
          userToken: response.data.user_token,
          message: response.data.message,
          status_code: response.data.status_code,
          accessType: 'login'
        };

        // Store tokens in localStorage
        localStorage.setItem('token', response.data.bearer_token);
        localStorage.setItem('user_token', response.data.user_token);
        localStorage.setItem('user', JSON.stringify(response.data.data));

        // Also store in sessionStorage for immediate access
        sessionStorage.setItem('token', response.data.bearer_token);
        sessionStorage.setItem('user_token', response.data.user_token);
        sessionStorage.setItem('user', JSON.stringify(response.data.data));

        // Set default axios headers
        axios.defaults.headers = {
          ...axios.defaults.headers,
          common: {
            ...axios.defaults.headers?.common,
            'Authorization': `Bearer ${response.data.bearer_token}`,
            'User-Token': response.data.user_token,
            'X-Device': 'web',
            'X-Platform': 'browser'
          }
        } as any;

        // Dispatch the success action
        dispatch({
          type: 'GET_LOGIN_SUCCESS',
          data: loginData,
          accessType: 'login'
        });

        // Navigate after successful verification
        setTimeout(() => {
          window.location.href = "/choose-how-watch";
        }, 1000);
      } else if(response.data.status_code==3) {
        const apiMessage = response?.data?.message || 'Something went wrong';
        toast(`${apiMessage}`);
        setInvalidError(apiMessage)
      }
    } catch (error: any) {
      
      console.error('OTP API error:', error);
      const apiMessage = error.response?.data?.message || error.message;
      setInvalidError(apiMessage)
      toast(`An error occurred during OTP verification. ${apiMessage}`);
      
      // Reset captcha on error
      setCapchaSelected('');
      if (window.grecaptcha && captchaRendered) {
        window.grecaptcha.reset();
      }
    }
  };

  return (
    <>
      <div className="loginrgstr-page">
        <div className="login_main">
          <div className='login-header'>
            <div className='container-fluid'>
              <div className='login-main'>
                <div className="login-logo text-center">
                  <a href="/"> <img src={logo} alt="" /></a>
                </div>
                <div className='loginheader-right'>
                  <a className='btn login-btn' href='/signin'>Sign In</a>
                  
                </div>
              </div>
            </div>
          </div>
          
          <section className='loginrgstrform-section'>
            <div className='loginrgstr-maincover'>
              <div className='container'>
                <div className='loginrgstr-main'>
                  <div className='loginrgstrhead-text text-center text-white'>
                    {(step === 1 || step === 2) && <h1>Unlimited movies, TV shows and more</h1>}
                    {(step === 1 || step === 2) && <p>Starts at <strong>$1.99</strong> monthly. Cancel at any time.</p>}
                    {step === 3 && <h1>Great, now let us<br></br> verify your email</h1>}
                    {/* {step === 3 && <p>Click the link we sent to <strong>{email}</strong> to Verify.</p>} */}
                    {step === 3 && <p>We've sent a 4-digit OTP to your registered email <strong>{email}</strong>.  <br></br>
                                    Please enter it below to verify your account.</p>}
                  </div>
                  
                  <div className='loginrgstr-formcover justify-content-center text-center'>
                    {(step === 1 || step === 2) && (
                      <h3 className='text-white py-3'>
                        Ready to watch? Enter your email to create or restart your membership.
                      </h3>
                    )}
                    {step === 3 && (
                      <h3 className='text-white py-3'>
                        Verifying your email will improve account security and help you receive important Darkroom communications.
                      </h3>
                    )}
                    
                    {/* Step 1: Username and Email */}
                    {step === 1 && (
                      <form onSubmit={handleFirstStep} className="loginrgstr-form justify-content-center">
                        <div className="form-grid">
                          <div className="form-group">
                            <div className='formsign-insidepanel w-100'>
                              <input type="text" placeholder="User Name" name="UserName" className="form-control" />
                              {usernameError && (
                                <p className='text-danger text-left'>
                                  <strong>X</strong><span>Please fill in a valid User Name</span>
                                </p>
                              )}
                            </div>
                            <div className='formsign-insidepanel w-100'>
                              <input type="email" placeholder="Email Address" name="email" className="form-control" />
                              {emailError && (
                                <p className='text-danger text-left'>
                                  <strong>X</strong><span>Please fill in a valid Email Address</span>
                                </p>
                              )}
                            </div>
                          </div>
                         
                          <div className="form-group justify-content-center">
                            <button type="submit" className="btn mt-3 w-100 justify-content-center">
                              <span>Get Started</span>
                              <i className='fa fa-angle-right'></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                    
                    {/* Step 2: Password */}
                    {step === 2 && (
                      <form onSubmit={handleSecondStep} className="loginrgstr-form justify-content-center">
                        <div className="form-grid">
                          <div className="form-group">
                            <input type="password" placeholder="Enter your password" name="password" className="form-control" />
                            <button type="submit" className="btn">
                              <span>Next</span>
                              <i className='fa fa-angle-right pl-2'></i>
                            </button>
                          </div>
                          {passwordError && (
                            <p className='text-danger text-left'>
                              <strong>X</strong><span>Please fill in a valid Password</span>
                            </p>
                          )}
                          {/* <div className='linkforgot-passtext pt-2 text-left'>
                            <a className="linkforgot-password" href="#">Forgot your password?</a>
                          </div> */}
                        </div>
                      </form>
                    )}
                    
                    {/* Step 3: OTP and Captcha - UPDATED WITH AUTO-FOCUS */}
                    {step === 3 && (
                      <form onSubmit={handleOtpStep} className="loginrgstr-form justify-content-center">
                        <div className="form-grid">
                          <div className="form-group">
                            <div className='carifycodeinpt-grid new-otp-box' style={{alignItems: 'center'}}>
                              {otp.map((digit, index) => (
                                <input
                                  key={index}
                                  ref={el => otpRefs.current[index] = el}
                                  type="tel"
                                  maxLength={1}
                                  name={`otp${index + 1}`}
                                  value={digit}
                                  onChange={(e) => handleOtpChange(index, e.target.value)}
                                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                  onPaste={handleOtpPaste}
                                  className="form-control"
                                />
                              ))}
                            </div>
                          </div>
                          <div className='mt-4'>
                             <div className="form-group justify-content-center captcha-box d-flex justify-content-center" style={{marginTop:'10px'}}>
                              <div ref={captchaRef} className="g-recaptcha"></div>
                              {error && <p className='text-danger text-center mt-2'>{error}</p>}
                            </div>
                          </div>
                         <div>
                          {invalidError && (
                           <div>
                            <p className='mt-3 mb-2 text-danger text-center'>{invalidError}</p>
                          </div>
                          )}
                           <button type="submit" className="btn" style={{margin: 'auto', marginTop:'16px'}}>
                              <span>Verify</span>
                              <i className='fa fa-angle-right pl-2'></i>
                            </button>
                         </div>
                        </div>
                        
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          
          <section className='loginrgstr-trendingsection' style={{ paddingBottom: '0' }}>
            <div className='container-fluid'>
              <div className='loginrgstr-trendingsmain'>
                <div>
                  <div className="flex_container">
                    <div className="outer_container">
                      <div className="title" style={{ marginBottom: '30px' }}>
                        <span>
                          <i>
                            <img src="https://www.darkroom.film/backend/public/uploads/admin/icon/202302181603_Trending.png" />
                          </i> 
                          Trending
                        </span>
                        <a className="viewall" href="/category?category_id=63&amp;category_name=Trending&amp;type=genre&amp;genre_type=3">
                          View All Trending
                        </a>
                      </div>
                    </div>
                    <div className="outer_container trending-container">
                      <div className="inner_container">
                        <ul className="ul_container">
                          {trendingData && trendingData.length > 0 ? (
                            trendingData.map((item: any, index: number) => (
                              <div key={index} className={`item_container ${index === 0 ? "expanded" : ""}`} style={{
                                zIndex: trendingData.length - index
                              }}>
                                <div className="item_number">
                                  {index + 1}
                                </div>
                                <div className="image_info_container">
                                  <div className="info_container">
                                    <div className="info_container_inner">
                                      <div className="info_number">
                                        <p>{index + 1}</p>
                                      </div>
                                      <div className="info_bottom_container">
                                        <div className="info_bottom_text">
                                          <h5>{item.video_title}</h5>
                                          <a href={`content?video_id=${item.video_id}&video_type=${item.video_type}`}>
                                            Watch now
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="image">
                                    <picture>
                                      <source srcSet={item.landscape_art_1280x720} type="image/webp" media="(max-width: 400px)" />
                                      <source srcSet={item.landscape_art_1280x720} type="image/jpeg" media="(max-width: 400px)" />
                                      <source srcSet={item.landscape_art_1280x720} type="image/jpeg" />
                                      <img className="" style={{ marginLeft: '0px' }} src={item.landscape_art_1280x720} alt="The Guilty" />
                                    </picture>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div>No trending data available.</div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          
          <section className='morereasons-section'>
            <div className='container'>
              <div className='morereasons-main'>
                <div className="title">
                  <span>
                    <i>
                      <img src="https://www.darkroom.film/backend/public/uploads/admin/icon/202308281843_TopPicks.png" />
                    </i>
                    More reasons to join
                  </span>
                </div>
              </div>
              <div className='morereasons-cardgrid'>
                <div className='morereasons-cardgroup'>
                  <div className='morereasons-cardpanel'>
                    <h3>A memorable collection</h3>
                    <p>Like celluloid archaeologists, we explore the world’s vaults of movies and TV, searching for meaningful stories. From this exercise, we have amassed over a thousand titles (and counting) from the Silent Era to this year, from every continent, from anime to festival pedigree, with the goal of finding real cinematic treasures. Chances are you’ll find something worth watching!</p>
                    {/* <div className="morereasons-icon">
                      <img src={yourTv} />
                    </div> */}
                  </div>
                </div>
                <div className='morereasons-cardgroup'>
                  <div className='morereasons-cardpanel'>
                    <h3>Less time searching</h3>
                    <p>Everybody hates the algorithms. In a study we did with industry and general public, the number one complaint of over 76% of those polled was that there was no good way to find something to watch. We do our best to provide advanced search functions, along with allowing users to create their own wish lists, to enable more movie watching and less looking around.</p>
                    {/* <div className="morereasons-icon">
                      <img src={WatchEverywhere} />
                    </div> */}
                  </div>
                </div>
                <div className='morereasons-cardgroup'>
                  <div className='morereasons-cardpanel' style={{display: 'block'}}>
                    <h3>New stuff weekly</h3>
                    <p>Every Friday we release a new batch of titles, and you can see what’s next directly on the platform! We offer a coming soon calendar with weekly updates.</p>
                    {/* <div className="morereasons-icon">
                      <img src={createProfilesKids} />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
          
          <section className='loginrgstrfaq-section'>
            <div className='container'>
              <div className='loginrgstrfaq-main'>
                <div className="title">
                  <span>Frequently Asked Questions</span>
                </div>
              </div>
              <div className='loginrgstrfaq-cardgrid'>
                {faqData.map((faq, index) => (
                  <div
                    key={index}
                    onClick={() => showhFaq(faqActive === index ? null : index)}
                    className={faqActive === index ? 'loginrgstrfaq-headgroup active' : 'loginrgstrfaq-headgroup'}
                  >
                    <div className='loginrgstrfaq-headpanel'>
                      <h3>{faq.name}</h3>
                      <span>
                        <i className={faqActive === index ? 'fa fa-minus' : 'fa fa-plus'}></i>
                      </span>
                    </div>
                    {faqActive === index && (
                      <div className='loginrgstrfaq-body'>
                        {faq.conts}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section>
            <div className="importantitem_main">
              <div className="importantitem_slider moviecommon-slider owl-carousel">
                {trendingData?.length &&
                  trendingData?.map((item: { video_title: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; }, index: Key | null | undefined) => (
                    <div className="importantitem_group" key={index}>
                      <p>{item.video_title}</p>
                    </div>
                  ))}
              </div>
            </div>
          </section>

          <LoginFooter />
        </div>
      </div>
    </>
  )
}

export default NewSignup;